import { DayPicker } from "react-day-picker";
import { AssortGroup } from "../../../models/AssortGroup";
import "../../../../style/calendar.scss";
// import format from "date-fns/format";
import "../../../../style/block.scss";
import "./style.scss";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import { addDays, format } from "date-fns";

interface IProps {
  item: AssortGroup;
  selectedDate: Date;
  setDateBetween: (date: Date) => void;
}

const CalendarPass: React.FC<IProps> = ({ item, selectedDate, setDateBetween }) => {
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();
  return (
    <div className="CalendarPass">
      <div className="calendar-container"> 
        <DayPicker
          mode="single"
          locale={locale}
          selected={selectedDate}
          fromDate={new Date()}
          onSelect={(date) => {
            setDateBetween(date ?? new Date());
          }}
          showOutsideDays
          modifiersClassNames={{
            selected: "my-selected",
            today: "my-today",
          }}
        />
      </div>

      <div className="container">
        <div className="flex-between-center">
          <span>{t("waznosc")}:</span>
          <b>
            {format(selectedDate, "dd.MM.yyyy")} - {format(addDays(selectedDate, item.dayValidate), "dd.MM.yyyy")}
          </b>
        </div>
        <div className="flex-between-center">
          <span>{t("wartosc_karnetu")}:</span>
          <b>
            {" "}
            {item.price} {t("zl")}
          </b>
        </div>
      </div>
    </div>
  );
};

export default CalendarPass;
